import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';

import { CFHttpClient } from '@mem-shared/cf-http-client';
import { UserSession } from '@mem-shared/user-session';
import { UtilService } from '@mem-shared/util.service';
import { MemberAuditRequest } from './memberAudit.model';
import { memberAuditInterface } from '../../claims-summary/interfaces/memberAudit.interface';

const memberAuditUrl = '/mas/pub/memberAudit.json';

@Injectable()
export class MemberAuditService implements memberAuditInterface {
  constructor(
    private http: CFHttpClient,
    private utilService: UtilService,
    private userSession: UserSession
  ) { }

  audit(transactionTypeCode: string, successInd: boolean, errorCode?: string, additionalInfo?: any) {
    const httpOptions = {
      headers: this.setHeaders()
    };

    const memberAuditRequest = new MemberAuditRequest();

    memberAuditRequest.accountId = this.userSession.getCurrentAccountId();
    memberAuditRequest.transactionTypeCode = transactionTypeCode;
    memberAuditRequest.transactionSuccessInd = successInd;
    memberAuditRequest.transactionErrorCode = errorCode;
    memberAuditRequest.additionalInfo = additionalInfo || {};

    // There is no point to return anything with aduit service.
    const auditUrl = window.location.origin + memberAuditUrl;
    this.http.post(auditUrl, memberAuditRequest, httpOptions).subscribe();
  }

  /**
   * SBS is looking for some additional headers
   * See SBS code:
   * MemberWeb/src/main/com/carefirst/member/present/filters/MemberAuthenticationFilter.java
   */
  protected setHeaders(existingHeaders?) {
    return new HttpHeaders()
      .set('nativeOS', this.utilService.getNativeOS())
      .set('device', this.utilService.getDeviceType());
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/audit/member-audit.service.ts